{
  "hello": "Ciao {name}!",
  "log-in-title": "Inserisci le tue credenziali per accedere",
  "log-in-data-not-correct": "Le credenziali non sono corrette",
  "log-in-forgot": "Hai dimenticato la password?",
  "log-in": "Accedi",
  "log-in-code-error": "Inserisci nuovamente il codice",
  "log-in-code-label": "Inserisci il codice TOTP generato nella tua app di autenticazione",
  "mfa-intro": "Per concludere il processo di Log in è necessario attivare l'autenticazione multi fattore. Puoi utilizzare due modalità alternative:",
  "mfa-list-intro": "<ul><li>Scannerizza il «QR CODE»</li><li>Oppure clicca su «Rileva il codice» e inseriscilo nella tua app di autenticazione</li></ul><div>Infine, inserisci qui sotto il codice generato dall'app. Se hai bisogno di supporto, contatta <a href=\"mailto:login@coreconsulting.it\">login@coreconsulting.it</a></div>",
  "code-reveal": "RILEVA IL CODICE",
  "code-label": "Dopo di che, inserisci qui il codice generato",
  "code-not-valid": "Il codice inserito non è valido",
  "confirm": "Conferma",
  "new-pswrd-title": "Scegli la tua nuova password",
  "pswrd-not-match": "Le password non coincidono",
  "password-char": "La password deve contenere almeno {length} caratteri",
  "password-numbers": ", almeno un numero",
  "password-uppercase": ", una lettera maiuscola",
  "password-special": ", un carattere speciale",
  "password-rejected": "La password non è stata accettata. {message}",
  "onboarding": "Onboarding",
  "reset-username": "Inserisci il tuo nome utente",
  "reset-password": "Reimposta password",
  "send": "Invia",
  "submission-error": " Non è stato possibile eseguire la richiesta, riprova",
  "verify-code-send": "Se il nome utente inserito è valido, riceverai un codice di verifica al tuo indirizzo e-mail. Se non hai ricevuto l'e-mail, verifica nello spam oppure contatta <a href=\"mailto:login@coreconsulting.it\">login@coreconsulting.it</a>",
  "insert-code": "Inserisci qui il codice",
  "insert-code-again": "Inserisci nuovamente il codice",
  "choose-password": "Scegli la tua password",
  "copy-code-success": "Codice copiato negli appunti",
  "mfa": "Autenticazione multi fattore",
  "confirm-password": "Conferma Password",
  "username": "Nome utente",
  "back": "Indietro",
  "log-in-no-provider": "Nessun provider di accesso specificato. Accedi a questa pagina tramite il link della tua applicazione.",
  "error-not-found-title": "Pagina non trovata",
  "error-generic-title": "Qualcosa è andato storto",
  "error-guidance": "Accedi a questo servizio tramite il link della tua applicazione.",
  "home-title": "Servizio di identità Coreconsulting",
  "home-intro": "Questo è il servizio di identità e autenticazione di Coreconsulting. Il suo scopo è autenticare gli utenti per le applicazioni che se ne servono e non è pensato per essere visitato direttamente.",
  "home-guidance": "Se sei arrivato direttamente a questa pagina, torna all'applicazione che stavi utilizzando e usa il suo link di accesso. L'accesso a questo servizio ha senso solo se avviato da un'applicazione connessa.",
  "auth-redirecting-to": "Reindirizzamento a",
  "auth-continue": "Continua",
  "auth-not-you": "Non sei tu? Torna al login",
  "auth-redirecting-in": "Reindirizzamento a {host} tra {seconds} secondi",
  "auth-redirecting-now": "Reindirizzamento a {host}…",
  "auth-already-in": "Sei già entrato nella piattaforma",
  "auth-back-to-login": "Torna alla pagina di login"
}
